import { apiClient } from './setupApi';

const API_URL = `${process.env.REACT_APP_API_URL}/v1/promotions`;

// Получить список акций компании
export const getCompanyPromotions = (params = {}) => {
  const queryParams = new URLSearchParams();
  
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      queryParams.append(key, params[key]);
    }
  });

  const queryString = queryParams.toString();
  const url = queryString ? `${API_URL}/admin/?${queryString}` : `${API_URL}/admin/`;
  
  return apiClient.get(url);
};

// Получить детали акции
export const getCompanyPromotion = (id) => {
  return apiClient.get(`${API_URL}/admin/${id}`);
};

// Создать новую акцию
export const createCompanyPromotion = (data) => {
  return apiClient.post(`${API_URL}/admin/`, data);
};

// Обновить акцию
export const updateCompanyPromotion = (id, data) => {
  return apiClient.put(`${API_URL}/admin/${id}`, data);
};

// Обновить статус акции
export const updateCompanyPromotionStatus = (id, status) => {
  return apiClient.patch(`${API_URL}/admin/${id}/status`, { status });
};

// Удалить акцию
export const deleteCompanyPromotion = (id) => {
  return apiClient.delete(`${API_URL}/admin/${id}`);
};

// Получить список городов
export const getCities = () => {
  return apiClient.get(`${API_URL}/admin/filials`);
};

// Получить список инициаторов
export const getInitiators = () => {
  return apiClient.get(`${API_URL}/admin/initiators`);
};

// Создать инициатора
export const createInitiator = (data) => {
  return apiClient.post(`${API_URL}/admin/initiators`, data);
};

// Получить инициатора
export const getInitiator = (id) => {
  return apiClient.get(`${API_URL}/admin/initiators/${id}`);
};


// Загрузить файл с клиентами
export const uploadFile = (formData) => {
  return apiClient.post(`${API_URL}/admin/files/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Валидировать файл
export const validateFile = (fileId) => {
  return apiClient.post(`${API_URL}/admin/files/validate`, { file_id: fileId });
};

// Получить статус файла
export const getFileStatus = (fileId) => {
  return apiClient.get(`${API_URL}/admin/files/${fileId}/status`);
};

// Создать кнопку акции
export const createPromotionButton = (data) => {
  return apiClient.post(`${API_URL}/admin/buttons`, data);
};

// Получить кнопки акции
export const getPromotionButtons = (id) => {
  return apiClient.get(`${API_URL}/admin/buttons/${id}`);
};

// Получить список кнопок
export const getButtons = () => {
  return apiClient.get(`${API_URL}/admin/buttons`);
};

// Загрузить баннер
export const uploadBanner = (file, lang) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('lang', lang);
  
  return apiClient.post(`${API_URL}/admin/banners/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
